module.exports = __webpack_public_path__ + "static/media/banner.8167e5f2.jpg";